jQuery(function(){
  
  initProductSelect();
  initCartEditTrigger();
  initProductPriceTrigger();
  
  jQuery('input.mob_cart_qty').on('change input', function(){   
  	var val = jQuery(this).val();
    var data_quantity_item = jQuery(this).attr('data-quantity-item-num');
    //alert(jQuery("input[data-quantity-item='"+data_quantity_item+"'").val());
    //alert(data_quantity_item);
    jQuery("input[data-quantity-item='"+data_quantity_item+"'").val(val);
  });
  
  jQuery('button.cart__update-control').click(function(){
  	//alert($(this).parents('form#cartform').serialize());
    jQuery(this).parents('form#cartform').submit();
  });
  
  jQuery('#main-nav li').each(function(i,li){
    var text = $(this).find('a').text();
    if(text == "SHOP" || text == "Shop" || text == "shop"){
    	$(this).find('a').html('<span class="navbg">'+text+'</span>');
    }
  });
});





function initProductPriceTrigger(){  
  
  let $checkedProductPrice = jQuery('.select-plan .checked .active-price').html();
  let $stickyPrice = jQuery('.sticky-footer .sticky-price').html($checkedProductPrice);
  $stickyPrice.html($checkedProductPrice);
  
  jQuery('input').on('change',function(){
    jQuery(this).parent().addClass('checked');
    jQuery(this).parent().siblings().removeClass('checked');

    let $activeProductPrice = jQuery('.select-plan .checked .new-price').html();
    //alert($activeProductPrice);
    $stickyPrice.html($activeProductPrice);
    
  });
}

function initProductSelect(){
  console.log('select fxn triggered');
  var buyBtn = jQuery('.add-form .buy-btn'),
      checkedClass = 'checked';

  jQuery('.select-plan').each(function(){
    var inputs = jQuery(this).find(':radio'),
        activeItem = inputs.filter(':checked');

    activeItem.parent().addClass(checkedClass);
    buyBtn.val(activeItem.attr('id'));

    inputs.on('change', stateHandler);
  });

  function stateHandler(){
    var hold = jQuery(this).parent();

    hold.addClass(checkedClass).siblings().removeClass(checkedClass);
    buyBtn.val(jQuery(this).attr('id'));
  }
}

function initCartEditTrigger() {



    const $triggerBtn = jQuery('.js-edit-toggle');

    function toggleViewHandler() {
        const $this = jQuery(this);
        const $updateCartBox = jQuery('.cart__update-wrapper');
        const $editCartBox = $this.closest('tr').next($updateCartBox);

        if ($this.hasClass('cart__edit--active')) {
            $this.removeClass('cart__edit--active');
            $editCartBox.addClass('cart__update--show');
        }else{
            $this.addClass('cart__edit--active');
            $editCartBox.removeClass('cart__update--show');
        }
    }

    $triggerBtn.on('click', toggleViewHandler)

}

